// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1431":"b66e6fdf","1936":"b66e6fdf","6092":"b66e6fdf","7176":"543ed54e","8459":"9782da4c","8936":"c1c98134"}[chunkId] + ".chunk.css";
};